// extracted by mini-css-extract-plugin
export var jumbotron = "jumbotron-module--jumbotron--2uZ15";
export var content = "jumbotron-module--content--1BScQ";